import lib from "../../assets/utils/lib";

export const formatSearchDate = (value) => {
  if (value == null || value === "") return "—";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? String(value) : d.toLocaleString();
};

export const isActiveStatus = (status) => lib.unifiedSearchIsActiveStatus(status);

export const formatEnrolleeName = (record) =>
  [record?.title ? `${record.title}.` : null, record?.first_name, record?.middle_name, record?.surname]
    .filter(Boolean)
    .join(" ")
    .trim() || "—";

export const formatPaName = (record) =>
  [record?.first_name, record?.surname].filter(Boolean).join(" ").trim() || "—";
